// extracted by mini-css-extract-plugin
module.exports = {"carousel":"_9330de7794--carousel--FCofi"};